@if (canEdit) {
    <button type="button"
            class="ace-btn btn-sm btn-primary"
            (click)="test()"
            helpTooltip
            helpContentId="long-running-process-synthetic.test"
            position="bottom">
        <i class="fa fa-heartbeat"></i> Test Service
    </button>
}
